module.exports = __webpack_public_path__ + "media/scss/webfonts/384AEE_0_0-5ed4ea80ba66bf6e927047c155e3aab8.woff";